export default "__VITE_ASSET__24c5d1c3__"